import axios from "../utils/axios";

// Get all agencies
export const getAgencies = async (params = {}) => {
    const response = await axios.get('/agencies', { params });
    return response.data;
};

// Get single agency
export const getAgency = async (id) => {
    const response = await axios.get(`/agencies/${id}`);
    return response.data;
};

// Create agency
export const createAgency = async (data) => {
    const response = await axios.post('/agencies', data);
    return response.data;
};

// Update agency
export const updateAgency = async (id, data) => {
    const response = await axios.put(`/agencies/${id}`, data);
    return response.data;
};

// Delete agency (soft delete)
export const deleteAgency = async (id) => {
    const response = await axios.delete(`/agencies/${id}`);
    return response.data;
};

// Force delete agency
export const forceDeleteAgency = async (id) => {
    const response = await axios.delete(`/agencies/${id}/force-delete`);
    return response.data;
};

// Restore agency
export const restoreAgency = async (id) => {
    const response = await axios.post(`/agencies/${id}/restore`);
    return response.data;
};

export const massDestroyAgencies = async (data) => {
    const response = await axios.delete('/agencies/mass-destroy', { data });
    return response.data;
};

export const massForceDeleteAgencies = async (data) => {
    const response = await axios.delete('/agencies/mass-force-delete', { data });
    return response.data;
};

export const massRestoreAgencies = async (data) => {
    const response = await axios.post('/agencies/mass-restore', data);
    return response.data;
};

// Helper to extract just the filename from a full URL or path
// const getFileName = (val) => {
//     if (!val) return undefined;
//     if (typeof val === 'string') {
//         return val.substring(val.lastIndexOf('/') + 1) || val;
//     }
//     if (val?.file_name) return val.file_name;
//     if (val?.url) return val.url.substring(val.url.lastIndexOf('/') + 1);
//     return val;
// };

// Duplicate agency by fetching it then creating a copy
export const duplicateAgency = async (id) => {
    // Get the original agency data
    const { data: original } = await axios.get(`/agencies/${id}`);
    const agency = original?.data || original;

    // Process features - extract just filenames from image URLs
    const features = agency?.features
        ? agency.features.map((f) => ({
            // image: getFileName(f.image),
            title: f.title,
            description: f.description,
        }))
        : undefined;

    // Process products - extract just filenames from URLs
    // const products = agency?.products
    //     ? agency.products.map((p) => {
    //         if (typeof p === 'string') return getFileName(p);
    //         if (p?.url) return getFileName(p.url);
    //         return p;
    //     })
    //     : undefined;

    // Prepare payload with modified title
    const payload = {
        title: {
            ar: `${agency?.title?.ar || ''} (نسخة)`,
            en: `${agency?.title?.en || ''} (Copy)`,
        },
        sub_title: agency?.sub_title || undefined,
        description: agency?.description || undefined,
        products_section_title: agency?.products_section_title || undefined,
        products_section_description: agency?.products_section_description || undefined,
        // image: getFileName(agency?.image),
        slug: agency?.slug ? `${agency.slug}-copy` : undefined,
        sort_order: agency?.sort_order ?? 0,
        is_active: agency?.is_active ?? 1,
        show_in_home: agency?.show_in_home ?? 1,
        features,
        // products,
    };

    const response = await axios.post('/agencies', payload);
    return response.data;
};
